'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcTooltip = require('rc-tooltip');

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _positions = require('positions');

var _positions2 = _interopRequireDefault(_positions);

require('./flyout.local.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var placementsMap = {
  tc: 'top center',
  bc: 'bottom center',
  cl: 'center right',
  cr: 'center left'
};
var TOOLTIP_PREFIX = 'common-ui-tooltip'; // Position arrow over selected element, not middle of tooltip

function placeArrow(tooltipEl, align) {
  var arrowEl = tooltipEl.querySelector('.' + TOOLTIP_PREFIX + '-arrow');
  var targetEl = this.getRootDomNode();
  var position = (0, _positions2.default)(arrowEl, placementsMap[align.points[0]], targetEl, placementsMap[align.points[1]]);

  if (align.points[0] === 'tc' || align.points[0] === 'bc') {
    arrowEl.style.top = '';
    arrowEl.style.left = position.left + 'px';
  } else {
    arrowEl.style.top = position.top + 'px';
    arrowEl.style.left = '';
  }
}

var Flyout = function Flyout(props) {
  var classes = (0, _classnames2.default)(props.className, TOOLTIP_PREFIX + '__theme--' + props.theme);
  var visibilityProps = {};

  if (props.defaultVisible !== undefined) {
    visibilityProps.defaultVisible = props.defaultVisible;
  }

  if (props.visible !== undefined) {
    visibilityProps.visible = props.visible;
  }

  return _react2.default.createElement(_rcTooltip2.default, _extends({}, visibilityProps, {
    id: props.id,
    prefixCls: TOOLTIP_PREFIX,
    trigger: props.triggers,
    overlayClassName: classes,
    placement: props.position,
    overlay: _react2.default.createElement('div', _extends({}, props.overlayProps, {
      className: TOOLTIP_PREFIX + '__overlay-wrap'
    }), props.label),
    onPopupAlign: placeArrow
  }), _react2.default.createElement('span', _extends({
    className: TOOLTIP_PREFIX + '__trigger-container'
  }, props.tooltipContainerProps), props.children));
};

Flyout.defaultProps = {
  position: 'top',
  theme: 'dark',
  triggers: ['click', 'focus', 'hover'],
  overlayProps: {},
  tooltipContainerProps: {}
};
Flyout.propTypes = {
  className: _propTypes2.default.string,
  position: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight']),
  defaultVisible: _propTypes2.default.bool,
  visible: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  theme: _propTypes2.default.oneOf(['dark', 'light']),
  triggers: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['click', 'focus', 'hover'])),
  id: _propTypes2.default.string,
  overlayProps: _propTypes2.default.object,
  tooltipContainerProps: _propTypes2.default.object
};
exports.default = Flyout;